@if (isConnectionInProgress) {
  <div class="d-flex align-items-center flex-column">
    <p class="connection-title mb-4">Connecting to <b>{{ androidDevice.LocationName }}</b></p>
    <span class="assign-loader mb-4"></span>
    <hr class="w-100 mt-0">
    <button mat-raised-button class="btn-cancel-connection" [mat-dialog-close]="false">Cancel</button>
  </div>
}
@else {
  <div mat-dialog-content class="py-1 position-relative">
    <mat-icon class="close-icon" svgIcon="close" [mat-dialog-close]="false"></mat-icon>
    <div class="form-row align-items-center form-container">
      <form #installAppForm="ngForm" name="installAppForm" (ngSubmit)="installApkFile()">
        <div class="panel">
          @let isDeviceConnectedToAdb = ipAddress | arrayIncludes: adbService.connectedIpAddresses.value;

          <h6 class="w-100">Install DDS Signage app</h6>
          <div class="assign-wrapper">
            <div class="inputs-block">
              <div class="button-container">
                @if (isConnectingToAdb) {
                  <div class="spinner-container">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
                <button type="button" class="add-icon-button btn-green" mat-mini-fab (click)="connectToADB()"
                  name="connectToAdb" [disabled]="!ipAddress?.length || isConnectingToAdb">
                    <mat-icon svgIcon="add" matTooltip="Connect to ADB"></mat-icon>
                </button>
              </div>

              <input class="form-control ip-address-input" name="ipAddress" [(ngModel)]="ipAddress" type="text"
                [dropSpecialCharacters]="false" mask="IP" [pattern]="ipAddressPattern" placeholder="000.000.000.000">
            </div>

            <div>
              <div class="button-container">
                @if (isApkInstalling) {
                  <div class="spinner-container">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  </div>
                }
                <button mat-raised-button class="btn-green" type="submit"
                  [disabled]="!isDeviceConnectedToAdb || isApkInstalling">Install</button>
              </div>

              <button type="button" class="ml-1" mat-icon-button (click)="updateSettings()" name="settings">
                <mat-icon class="align-baseline" svgIcon="setting"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </form>

      <mat-divider class="w-100"></mat-divider>

      <form #connectAndroidDeviceForm="ngForm" name="connectAndroidDeviceForm" (ngSubmit)="connect()">
        <div class="panel">
          <h6 class="w-100">Assign a new device</h6>
          <div class="assign-wrapper">
            <div class="inputs-block">
              <input class="form-control text-uppercase" placeholder="Device code" name="code" #code="ngModel"
                [(ngModel)]="androidDevice.Code" required>

              <input class="form-control" placeholder="Location name" name="locationName" #locationName="ngModel"
                [(ngModel)]="androidDevice.LocationName" required>
                <mat-select name="categoryId" placeholder="Select a category" [(ngModel)]="androidDevice.CategoryId"
                  [disableOptionCentering]="true" panelClass="mat-location-select">
                    <mat-option *ngFor="let category of categories"
                      [value]="category.Id">{{ category.Name }}</mat-option>
                    <mat-option disabled *ngIf="!categories?.length">There are no categories in the system</mat-option>
                </mat-select>
              </div>

              <div class="d-flex">
                <button mat-raised-button matTooltip="Cancel" class="w-40" [mat-dialog-close]="false">Cancel</button>
                <button mat-raised-button matTooltip="Connect device" class="ml-2 w-50 btn-green" type="submit"
                  [disabled]="!connectAndroidDeviceForm.valid">Connect</button>
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>
}
